module.exports = __webpack_public_path__ + "static/img/catalogMore.57948961.svg";